import React, { useRef } from 'react';
import './Navigation.css';
import { HiOutlineMusicNote } from 'react-icons/hi';
import { Link, Route, Routes } from 'react-router-dom';

const Navigation = () => {
  const Modal_E = () => {
    const body = document.querySelector('body');
    body.id = 'body_modal';
  };

  const General_E = () => {
    const body = document.querySelector('body');

    body.id = 'body_modal2';
  };
  return (
    <div className="Navigation">
      <div className="Navigation_left" onClick={General_E}>
        <Link className="Link L_home" to={'/'}>
          Kang ik chi
        </Link>
      </div>

      <div className="Navigation_right">
        {/* <audio className="Navigation_right_2">
          <HiOutlineMusicNote />
        </audio> */}
        <audio
          src="music/music1.mp3"
          loop
          controls
          id="myAudio"
          className="Navigation_right_2"
        >
          <source src="music/music1.mp3" type="audio/mp3" />
          오디오 지원되지 않는 브라우저
        </audio>

        <div className="Navigation_right_3" onClick={Modal_E}>
          <Link className="Link L_appreciate" to={'/Appreciateq'}>
            작품감상
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
